var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('proof-management',{attrs:{"my-jobs":_vm.myJobs,"bulk-cert":true,"modal-name":_vm.modalName},on:{"editProof":_vm.editProof,"complete":_vm.complete}})}
var staticRenderFns = []

export { render, staticRenderFns }